import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar/Navbar";
import "./HomePage.css";
import "react-datepicker/dist/react-datepicker.css";
import { Chart as ChartJS, ArcElement, Tooltip, Legend, Title } from 'chart.js';
import CandidateDash from "./HomePage/CandidateDash";
import EmployeeDash from "./HomePage/EmployeeDash";
import AdminDash from "./HomePage/AdminDash";

// Register all required Chart.js elements
ChartJS.register(ArcElement, Tooltip, Legend, Title);

const HomePage = () => {
  const [role, setRole] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const interval = setInterval(() => {
      const storedRole = localStorage.getItem("role");
      if (storedRole) {
        setRole(storedRole);
        clearInterval(interval);
      }
    }, 200);

    return () => clearInterval(interval);
  }, []);

  if (role === null) {
    return (
      <div className="App">
        <Navbar />
          <div className="main-content">
        <div className="text-center py-5">
          <span className="spinner-border" role="status" aria-hidden="true"></span>
          <span className="ms-2">Loading...</span>
        </div>
      </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Navbar />
         <div className="main-content">
      <div className="container-fluid mt-4">
        {(role === "ROLE_CANDIDATE" || role === "ROLE_CONTRACT") && <CandidateDash />}
        {role === "ROLE_EMP" && <EmployeeDash />}
        {role === "ROLE_ADMIN" && <AdminDash />}
      </div>
    </div>
   </div>
  );
};

export default HomePage;